export default __webpack_public_path__ + "static/media/ic_discord.d4467cdd.svg";